(function () {
  document.documentElement.classList.add('clupp-js');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // 1) Scroll reveal de secciones
  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if ('IntersectionObserver' in window && sections.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('clupp-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  } else {
    sections.forEach(function (section) {
      section.classList.add('clupp-in-view');
    });
  }

  // 2) Duplicar el contenido de cada marquee para loop infinito sin salto
  document.querySelectorAll('.clupp-marquee__track').forEach(function (track) {
    track.insertAdjacentHTML('beforeend', track.innerHTML);
  });
})();
